module.exports = __webpack_public_path__ + "img/image.9b9b778d.svg";